// extracted by mini-css-extract-plugin
export default {"overview":"HypothesisPage_overview__InTBH","overviewColumn":"HypothesisPage_overviewColumn__UH732"};